import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=e075459e&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=e075459e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e075459e",
  null
  
)

export default component.exports